<template>
  <button
    class="nav-btn critical-component-hide"
    :class="[
      $blockClass(blockClass, 'nav-btn'),
      !prevStep ? 'nav-btn--first' : '',
    ]"
  >
    <div
      class="nav-btn__dir nav-btn__dir--prev"
      @click="handlePrevClick"
    >
      <span
        class="nav-btn__icon"
        v-html="$icon('direction.arrow.left')"
      />
    </div>

    <span class="nav-btn__label body-2">
      {{ $string('bedVisualizer.navigationButton') }} <em>{{ nextStep }}</em>
    </span>

    <div
      class="nav-btn__dir nav-btn__dir--next"
      @click="handleNextClick"
    >
      <span
        class="nav-btn__icon"
        v-html="$icon('direction.arrow.right')"
      />
    </div>
  </button>
</template>

<script>

/**
 * Vue: Nav btn (nav-btn)
 * -----------------------------------------------------------------------------
 * Displays contents of nav btn.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Boolean} isMobile - Is mobile state.
 * @param {String} nextStep - Next step name.
 * @param {String} prevStep - Prev step name.
 */

export default {
  name: 'NavBtn',

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
    nextStep: {
      type: String,
      default: '',
    },
    prevStep: {
      type: String,
      default: '',
    },
  },

  emits: ['prev-page', 'next-page'],

  computed: {

    /**
     * Compute label classes.
     */
    labelClasses() {
      return this.isMobile ? 'body-2' : 'body-1'
    },
  },

  methods: {

    /**
     * Handle previous click.
     */
    handlePrevClick() {
      this.$emit('prev-page')
    },

    /**
     * Handle next click.
     */
    handleNextClick() {
      this.$emit('next-page')
    },
  },
}
</script>

<style lang="scss">
@import './nav-btn';
</style>
